module.exports = __webpack_public_path__ + "src/assets/img/engine_two.53714740.svg";